


















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class IndicadorCell extends Vue {
  @Prop() public readonly data!: IIndicador;
  @Prop({ default: '' }) public readonly tipo!: string;
  @Prop({ default: true }) public readonly showId!: boolean;

  get url(): string {
    return `https://dashboard.parceirosproteauto.com.br/painel/indicador/perfil.php?id=${this.data.id}`;
  }

  get nome(): string {
    return this.data.nome + ' ' + this.data.sobrenome;
  }
}
